function EmbedSocialForm() {
    return (
        <div style={{ backgroundColor: "#f8f9fa" }}>
            <div className="embedsocial-forms-iframe" data-ref="9b66b66e1190b11ec0e90d25d0610824a540ad1e" data-widget="true" data-height="auto"></div>
        </div>
    );
}

export default EmbedSocialForm;